import { createFeatureSelector, createSelector, createSelectorFactory, resultMemoize } from '@ngrx/store';
import * as fromSearch from './search.reducer';

export const selectSearchState = createFeatureSelector<fromSearch.SearchState>(fromSearch.searchFeatureKey);

export const selectSearchHistory = createSelector(
    selectSearchState,
    (searchState: fromSearch.SearchState) => searchState.searchHistory
);

export const selectSearchResult = createSelector(
    selectSearchState,
    (searchState: fromSearch.SearchState) => searchState.searchResult
);

export const selectSearchTermAndErrorsAndResult = createSelector(
    selectSearchState,
    ({
        searchResult,
        searchTerm,
        orderNumberSearchResult,
        searchError,
        electronicsTabSearchError: electronicsTabSearchError,
    }) => ({
        searchResult,
        searchTerm,
        orderNumberSearchResult,
        searchError,
        electronicsTabSearchError,
    })
);

export const selectOrderNumberSearchResult = createSelector(
    selectSearchState,
    (searchState: fromSearch.SearchState) => searchState.orderNumberSearchResult
);

export const selectPreviousSearchResult = createSelector(
    selectSearchState,
    (searchState: fromSearch.SearchState) => searchState.previousSearchResult
);

export const selectSearchError = createSelector(
    selectSearchState,
    (searchState: fromSearch.SearchState) => searchState.searchError
);

export const selectElectronicsTabSearchError = createSelector(
    selectSearchState,
    (searchState: fromSearch.SearchState) => searchState.electronicsTabSearchError
);

const primitiveArrayComparer = (a: any[], b: any[]): boolean =>
    a.length === b.length && a?.every((el) => b?.includes(el)) && b?.every((el) => a?.includes(el));

const selectSearchTermWithoutRepeatFactory = createSelectorFactory((projectionFun) =>
    /**
     * Video explaining `createSelectorFactory`: https://youtu.be/E7GKnjGCXzU?t=441 (starts at the interesting part 🚀)
     *
     * Using resultMemoize instead of defaultMemoize because of the following reason:
     *
     * The signiture of defaultMemoize:
     * projectionFn: AnyFn, isArgumentsEqual?: ((a: any, b: any) => boolean) | undefined, isResultEqual?: ((a: any, b: any) => boolean) | undefined)
     *
     * Note that `isArgumentsEqual` gets full state objects for comparison
     * while `isResultEqual` compares the selected values.
     *
     * In this case `isArgumentsEqual` is `undefined` as we are not interested in the calling arguments or even better,
     * just use `resultMemoize`.
     */
    resultMemoize(projectionFun, primitiveArrayComparer)
);

export const selectSearchTerm = selectSearchTermWithoutRepeatFactory(
    selectSearchState,
    (searchState: fromSearch.SearchState) => searchState.searchTerm
);

export const selectElectronicsTabSearchTerm = selectSearchTermWithoutRepeatFactory(
    selectSearchState,
    (searchState: fromSearch.SearchState) => searchState.electronicsTabSearchTerm
);
